import MatterNotesContainer from "@/components/features/matter/notes/MatterNotesContainer";
import { useRedirectIfMatterDeleted } from "@/hooks/useRedirectIfMatterDeleted";
import { retrieveMatterQueryOptions } from "@/lib/data/react-query/matters/matter";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/matters/$matterId/_layout/notes")({
  component: RouteComponent,
});

function RouteComponent() {
  const { matterId } = Route.useParams();
  const { data: matterDetails } = useSuspenseQuery(
    retrieveMatterQueryOptions(matterId),
  );

  const matterData = matterDetails.data;
  const isDeletedMatter = Array.isArray(matterData) || !matterData.id;
  useRedirectIfMatterDeleted({ matterId, isDeletedMatter });
  if (isDeletedMatter) {
    return null;
  }

  return <MatterNotesContainer notes={[]} matter={matterData} />;
}
